import {EventType, EventKind} from 'services/analytics/const';
import {buildEventCreator, overrideKeys} from 'services/analytics';

type TransferEventName = EventKind.TransferSavedToNextDay | EventKind.RedistributeSaved;

export const converter = overrideKeys<TransferMoneyEventPayload>({
  savedAmount: 'saved_amount',
  daysRemaining: 'days_remaining',
});

export function createEvent(name: TransferEventName): EventFactory<TransferMoneyEventPayload> {
  return buildEventCreator<EventType.Detailed, TransferMoneyEventPayload>({name, converter});
}

export const createRedistributeSavedEvent = createEvent(EventKind.RedistributeSaved);
export const createTransferSavedToNextDayEvent = createEvent(EventKind.TransferSavedToNextDay);
